import React, { useMemo } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button } from '@americanexpress/dls-react';
import { isSideNavMarketPathname } from '../../utils/ModuleMap';
import { getIntlLinks } from '../../redux/selectors';
import styles from './styles/PrivacySideNav.scss';
const TAG_REGEX = /<(\w+)>/;
const PrivacySideNav = () => {
  const intl = useIntl();
  const activeLocale = intl.locale;
  const linksFromStore = useSelector(state => getIntlLinks(state, activeLocale));
  const isSideNavMarket = useMemo(() => isSideNavMarketPathname(typeof window !== 'undefined' ? window.location.pathname : ''), []);

  // Build nav items dynamically from locale messages matching 'privacySideNav.url*' keys
  const navItems = useMemo(() => Object.keys(intl.messages)
  // Filter for side nav URL message keys (e.g. privacySideNav.url1, url2, etc.)
  .filter(key => key.startsWith('privacySideNav.url'))
  // Sort numerically by the suffix number to maintain display order
  .sort((a, b) => {
    const numA = Number.parseInt(a.replace('privacySideNav.url', ''), 10);
    const numB = Number.parseInt(b.replace('privacySideNav.url', ''), 10);
    return numA - numB;
  }).map(key => {
    const message = intl.messages[key];
    // Extract the rich text tag name (e.g. 'privacySideNavUrl1') from the message
    const match = message.match(TAG_REGEX);
    const tag = match ? match[1] : null;
    // Resolve the tag to an actual URL from the links store
    let url = null;
    if (tag) {
      if (typeof (linksFromStore === null || linksFromStore === void 0 ? void 0 : linksFromStore.get) === 'function') {
        url = linksFromStore.get(tag);
      } else {
        url = (linksFromStore === null || linksFromStore === void 0 ? void 0 : linksFromStore[tag]) || null;
      }
    }
    return {
      id: key,
      label: key,
      tag,
      url
    };
  }), [intl.messages, linksFromStore]);
  const handleNavClick = item => {
    if (item.url) {
      window.open(item.url, '_blank', 'noopener,noreferrer');
    }
  };
  if (!isSideNavMarket) {
    return null;
  }
  return /*#__PURE__*/React.createElement("nav", {
    className: styles.sideNav,
    "aria-label": "Privacy navigation"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.navHeader
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles.navTitle
  }, intl.messages['privacySideNav.learnMore'] && /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "privacySideNav.learnMore"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: styles.navList
  }, navItems.map(item => /*#__PURE__*/React.createElement("li", {
    key: item.id,
    className: styles.navItem
  }, /*#__PURE__*/React.createElement(Button, {
    tag: "button",
    className: styles.navLink,
    onClick: () => handleNavClick(item)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: item.label,
    values: item.tag ? {
      [item.tag]: chunks => chunks
    } : undefined
  }))))));
};
export default PrivacySideNav;